import Axios from 'axios';
import store from '@/store';
import { log } from '@/utils/common';
import { showSpinner, hideSpinner } from './spinnerManager';

const globalConfig = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

export const axiosGet = Axios.create({
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Origin": "*"
  },
  withCredentials: true
});

const instance = Axios.create(globalConfig);

instance.interceptors.request.use(
  (config) => {
    if (!config.noSpinner) {
      showSpinner(store);
    }

    return config;
  },
  (error) =>
    // Do something with request error
    Promise.reject(error)
  ,
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    // Do something with response data
    // response.data.errorMessage = 'ㄹㄹㄹㄹㄹㄹㄹㄹㄹㄹ';

    if (!response.config.noSpinner) {
      hideSpinner(store);
    }

    if (response.data.errorType || response.data.errorMessage) {
      console.error(response.data);
      return Promise.reject(response.data);
    }
    log('http::response.use::', response);

    return response;
  },
  (error) => {
    hideSpinner(store);

    log('http::response.use::', error);
    store.dispatch('newError', {
      msg: '네트워크 에러.',
      error,
    });
    // Do something with response error
    return Promise.reject(error);
  },
);

const baseUrl = process.env.API_BASE_URL;
const defaultPostHeaders = {
  'Content-Type': 'application/json;charset=UTF-8',
};
const defaultGetHeaders = {
  'Accept': 'application/json',
}

const httpInstance = {
  get(uri, headers = {}, additionalConfig = {}) {
    const url = `${baseUrl}${uri}`;
    const config = {
      headers: {
        ...defaultGetHeaders,
        ...headers,
      },
      ...additionalConfig
    };

    const promise = instance.get(url, config);
    return promise.then(({ data }) => data);
  },

  post(uri, params = {}, headers = {}, additionalConfig = {}) {
    // do post
    const url = `${baseUrl}${uri}`;
    const config = {
      headers: {
        ...defaultPostHeaders,
        ...headers,
      },
      ...additionalConfig,
    };
    const promise = instance.post(url, params, config);
    return promise.then(({ data }) => data);
  },
  mockPost(uri, params = {}, expectingReturnVal = {}, timeout = 2 * 1000) {
    const url = `${baseUrl}${uri}`;
    console.warn(`Mocking api - uri ${url} with params`, params);
    showSpinner(store);
    return new Promise((resolve) => {
      setTimeout(() => {
        hideSpinner(store);
        resolve(expectingReturnVal);
      }, timeout);
    });
  },
};


export const axios = instance;
export const http = httpInstance;
export default http;



// WEBPACK FOOTER //
// ./src/utils/http.js